import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";

const actions = {
  getSmStorageLosses({ commit }, payload) {
    return api.fetchFull(endpoints.SM_STORAGE_LOSSES, payload, commit, (response) => {
      commit("SET_SM_STORAGE_LOSSES", response.data || []);
      return response;
    });
  },

  getSmStorageLossByUuid({ commit }, payload) {
    return api.fetchFull(`${endpoints.SM_STORAGE_LOSSES}/${payload.uuid}`, payload, commit, (response) => {
      commit("SET_SM_STORAGE_LOSS", response.data || null);
      return response;
    });
  },

  createSmStorageLoss({ commit }, payload) {
    return api.post(endpoints.SM_STORAGE_LOSSES, payload, commit, (response) => response);
  },

  updateSmStorageLoss({ commit }, payload) {
    return api.put(`${endpoints.SM_STORAGE_LOSSES}/${payload.uuid}`, payload, commit, (response) => response);
  },

  deleteSmStorageLoss({ commit }, payload) {
    return api.remove(`${endpoints.SM_STORAGE_LOSSES}/${payload.uuid}`, payload, commit, (response) => response);
  },
};

export default actions;
